/**
 * 获取应急运力企业数据
 */
import request from "_private/utils/request";
// 应急企业title详情数据
export function getEmergencyCompanyAndOtherNum() {
  return request({
    url: "/emergencyCompanyInvitationInfo/getEmergencyCompanyAndOtherNum",
    method: "post",
    headers: { type: "json" }
  });
}

// 新增应急企业邀请数据
export function getInvitationCompanyTree() {
  return request({
    url: "/emergencyCompanyInvitationInfo/getInvitationCompanyTree",
    method: "post",
    headers: { type: "json" }
  });
}

// 保存应急企业邀请数据
export function saveCompanyData(data) {
  return request({
    url: "/emergencyCompanyInvitationInfo/save",
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 取消/再邀请/删除应急企业
export function changeStatus(data) {
  return request({
    url: "/emergencyCompanyInvitationInfo/changeStatus",
    method: "post",
    // headers: { type: "json" },
    data
  });
}

// 指数看板接口
export function findByTypeIndexBoard(data) {
  return request({
    url: "/bigDataExponentDayReport/findByTypeIndexBoard",
    method: "post",
    headers: { type: "json" },
    data
  });
}
